import { EmplacementForm } from "@features/stock/components/EmplacementForm";
import { ROUTES } from "@features/stock/config/constants";
import { usePermissions } from "@lib/hooks/usePermissions";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/emplacements/create")({
  loader: requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.CREATE),
  component: CreateEmplacementComponent,
});

function CreateEmplacementComponent() {
  const { can } = usePermissions();
  const navigate = useNavigate();

  if (!can("stock.emplacements.create")) {
    return <div className="p-6">Accès non autorisé</div>;
  }

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.EMPLACEMENTS.LIST });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Nouvel Emplacement</h1>
      <EmplacementForm mode="create" onSuccess={handleSuccess} />
    </div>
  );
}
